import React, {createRef} from "react"
import {findDOMNode} from "react-dom"

import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import ProjectSession from "../../../../model2/project/project-session"
import ProjectTree_New, {
    ITreeSelectorParent
} from "../../../../gd-ui/select-parent-new/components/tree-new/project-tree-new"
import {EntityType} from "../../../../gd/const/item"
import {SpaceProto} from "../../../../model2/space/space-proto"
import {ProjectsTreeSortType} from "../../../../../layout/menu/components/space-preferences/preferences"
import {NavigationSectionType} from "../../../../model2/navigation/@const"
import {ItemDisplay} from "../../../../model2/item/item-model"
import {MoveTo_Manager} from "../../model/manager"

type Props = {
    manager                 : MoveTo_Manager

    parentsFor              : EntityType
    canBeNull               : boolean
    displayWorkspaceRoot    : boolean
}

// const debug = 'ModalMoveTo_ProjectsTree'
const debug = false

export default class ModalMoveTo_ProjectsTree extends React.Component<Props> implements ITreeSelectorParent {

    private refScroll           : any = createRef()
    public multiselect          : boolean = false       // needed for tree interface

    static defaultProps = {
        parentsFor              : EntityType.PROJECT,
        canBeNull               : true,
        displayWorkspaceRoot    : true,
    }

    constructor(props: Props) {
        super(props)
    }

    componentDidMount() {
        setTimeout(()=>{
            this.scrollToTarget()
        }, 0)
    }

    // Interface method
    get parentsFor():EntityType {
        return this.props.parentsFor
    }

    get value():ID|null {
        return this.props.manager.targetProject?.id || null
    }

    get selectedProjects():ID[] {
        return this.value ? [this.value] : []
    }

    scrollToTarget = () => {
        const selfNode: any = findDOMNode(this.refScroll.current)
        const itemNodeIdClass = 'projectId-{0}'.f(this.value)
        const node = selfNode?.getElementsByClassName(itemNodeIdClass)[0] // find node to scroll to

        debug && console.log(debug, "scrollToTarget node", node?.offsetTop, node, selfNode)

        if (node) {
            this.refScroll.current?.setScrollTop(node.offsetTop, true, 0)
        }
    }

    onToggleExpand = (project: ProjectSession) => {
        debug && console.log(debug, 'onToggleExpand', project)
        project.treeIsExpandedProjectSelector = !project.treeIsExpandedProjectSelector
        this.forceUpdate()
    }

    render() {
        const projectsSpaceHasVisibleRootProjects = _.some(gd.spaces.projects.rootProjects, (projectSession: ProjectSession) => {
            return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(projectSession.treeDisplay)
        })

        const spaces = _.filter(gd.spaces.spacesWithProjects, (space: SpaceProto) => space.enabled)

        debug && console.log(debug, 'render', spaces, this.selectedProjects, gd.spaces.projects.rootProjects)

        return (
            <VScroll ref={this.refScroll} containerClass="p-v-0 p-r-5 p-l-8">
                <div className="ui5-menu p-0">
                    {_.map(spaces, space=>{
                        // skip projects space if no projects visible
                        if (space.id === NavigationSectionType.PROJECTS && !projectsSpaceHasVisibleRootProjects) {
                            return null
                        }

                        return <ProjectTree_New key                 = {space.id}
                                                parentSelector      = {this}
                                                sortType            = {ProjectsTreeSortType.ALPHABETICAL}
                                                rootProjects        = {space.rootProjects}
                                                section             = {space}
                                                initialRootExpanded = {this.props.manager.targetProject?.space?.id === space.id}
                                                applyTreeDisplay    = {true}
                                                onSelect            = {this.props.manager.setTargetProject}
                                                onToggleExpand      = {this.onToggleExpand}/>
                    })}
                </div>
            </VScroll>
        )
    }
}